"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const model_1 = require("../../model");
const HistMap_1 = __importDefault(require("../HistMap"));
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const Fab_1 = __importDefault(require("@mui/material/Fab"));
const theme_1 = require("../../theme");
const Drawer_1 = __importDefault(require("@mui/material/Drawer"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Sidebar_1 = __importDefault(require("../Sidebar"));
const useStaging_1 = __importDefault(require("../../hooks/useStaging"));
const AppContainer = (0, styles_1.styled)("div")({
    width: "100vw",
    height: "100vh",
});
const StyledHistMap = (0, styles_1.styled)(HistMap_1.default)({
    height: "100%",
});
const SidebarFab = (0, styles_1.styled)(Fab_1.default)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: theme.zIndex.appBar,
}));
/**
 * State related to controlling sidebar Drawer.
 */
function useDrawer(theme) {
    const smallScreen = (0, material_1.useMediaQuery)(theme.breakpoints.down("sm"));
    const [open, setOpen] = (0, react_1.useState)(!smallScreen);
    const handleOpen = (0, react_1.useCallback)(() => setOpen(true), []);
    const handleClose = (0, react_1.useCallback)(() => setOpen(false), []);
    return {
        open,
        handleOpen,
        handleClose,
        variant: smallScreen ? "temporary" : "persistent",
    };
}
function HistMapApplication(props) {
    const { hits, geojsons, theme = theme_1.darkTheme, className } = props;
    const drawer = useDrawer(theme);
    const [options, stagingOptions, setStagingOptions] = (0, useStaging_1.default)(model_1.DefaultAppOptions);
    const selectedHits = (0, react_1.useMemo)(() => hits.filter((hit) => (0, model_1.checkHit)(hit, options.hit)), [hits, options]);
    const selectedFrontLines = (0, react_1.useMemo)(() => geojsons.filter((frontLine) => (0, model_1.checkFrontLine)(frontLine, options.frontLine)), [geojsons, options]);
    return (react_1.default.createElement(AppContainer, { className: className },
        react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(StyledHistMap, { hits: selectedHits, geojsons: selectedFrontLines }),
            react_1.default.createElement(Tooltip_1.default, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u043E\u0438\u0441\u043A\u0430" },
                react_1.default.createElement(SidebarFab, { onClick: drawer.handleOpen },
                    react_1.default.createElement(Menu_1.default, null))),
            react_1.default.createElement(Drawer_1.default, { anchor: "left", open: drawer.open, onClose: drawer.handleClose, variant: drawer.variant },
                react_1.default.createElement(Sidebar_1.default, { onBack: () => drawer.handleClose(), options: stagingOptions, onChange: setStagingOptions })))));
}
exports.default = HistMapApplication;
